import client from "api/client";

// F1 — contentTypesApi. Load once at app start and cache the slug→id map;
// list/filter endpoints take content_type_id (a UUID), not the slug (quirk #3).

export const listContentTypes = async () => {
  const { data } = await client.get("/content-types");
  return data.items ?? [];
};

// Build a { slug: contentTypeId } lookup from a list of content types. The
// ContentTypeResponse UUID field is `id` (older payloads used `content_type_id`).
export const buildSlugIdMap = (items = []) =>
  items.reduce((map, type) => {
    if (type.slug) map[type.slug] = type.id ?? type.content_type_id;
    return map;
  }, {});
